import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Company from '../entities/company'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface CompanyState extends ListState<Company>{
    editCompany:Company
}
class UserMutations extends ListMutations<Company>{

}
class CompanyModule extends ListModule<CompanyState,any,Company>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Company>(),
        loading:false,
        editCompany:new Company(),
        AppName:''
    }
    actions={
        async getPaged(context:ActionContext<CompanyState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Company/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Company>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getAll(context:ActionContext<CompanyState,any>){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Company/GetAll');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Company>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getCompanyName(context:ActionContext<CompanyState,any>){
          
            
            let reponse=await Ajax.get('/api/services/app/Common/GetCompanyName');
            //console.log(reponse.data.result.companyName);
            context.state.AppName=reponse.data.result.companyName;
        },
        async create(context:ActionContext<CompanyState,any>,payload:any){
            await Ajax.post('/api/services/app/Company/Create',payload.data);
        },
        async update(context:ActionContext<CompanyState,any>,payload:any){
            await Ajax.put('/api/services/app/Company/Update',payload.data);
        },
        async delete(context:ActionContext<CompanyState,any>,payload:any){
            await Ajax.delete('/api/services/app/Company/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CompanyState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Company/GetById?Id='+payload.id);
            return reponse.data.result as Company;
        },
        async getEquipmentCount(context:ActionContext<CompanyState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Company/GetEquipmentCount?type='+payload.data);
            if(payload.data==0){
                context.state.list=reponse.data.result.items;
                return 1;
            }else{
                return reponse.data.result.items;
            }
            
        }
    };
    mutations={
        setCurrentPage(state:CompanyState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CompanyState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CompanyState,company:Company){
            
            state.editCompany=company;
            //console.log(state.editFloor);
        }
        
    }
}
const companyModule=new CompanyModule();
export default companyModule;